import { useEffect, useState } from 'react';

/**
 * The current time, re-read every `intervalMs` while `active`.
 *
 * For lines that count time on their own between server reads (an import's
 * elapsed time and time left). Stopped, it keeps the last value.
 */
export function useNow(active: boolean, intervalMs = 30_000): number {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    if (!active) return;
    setNow(Date.now());
    const id = setInterval(() => setNow(Date.now()), intervalMs);
    return () => clearInterval(id);
  }, [active, intervalMs]);
  return now;
}
